module.exports = __webpack_public_path__ + "img/elasticsearch.f9dd3807.svg";